import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";

import { useMutation } from "react-apollo-hooks";
import {
  ADMIN_DELIVERY_BOX_ASYNC_SELECT_MUTATION,
  ADMIN_DELIVERY_BOX_DETAIL_QUERY,
} from "../Queries";

const DeliveryBoxAsyncSelect = ({ onChange, value }) => {
  const [loading, setLoading] = useState(true);
  const [inputValue, setInputValue] = useState("");

  const [AdminDeliveryBoxAsyncSelectMutation] = useMutation(
    ADMIN_DELIVERY_BOX_ASYNC_SELECT_MUTATION
  );
  const [AdminDeliveryBoxDetailMutation] = useMutation(
    ADMIN_DELIVERY_BOX_DETAIL_QUERY
  );

  const loadOptions = async (inputValue) => {
    const {
      data: { AdminDeliveryBoxAsyncSelect },
    } = await AdminDeliveryBoxAsyncSelectMutation({
      variables: {
        take: 20,
        skip: 0,
        keyword: inputValue,
      },
    });

    if (AdminDeliveryBoxAsyncSelect.count > 0) {
      return AdminDeliveryBoxAsyncSelect?.deliveryBoxes.map((item) => ({
        value: item.id,
        label: `${item.user.name}(${item.user.userId})`,
      }));
    }
  };

  useEffect(() => {
    const defaultValue = async () => {
      if (!value) {
        return;
      }
      const {
        data: { AdminDeliveryBoxDetail },
      } = await AdminDeliveryBoxDetailMutation({
        variables: {
          id: value,
        },
      });

      const inputValue = {
        value: AdminDeliveryBoxDetail.id,
        label: `${AdminDeliveryBoxDetail.user.name}(${AdminDeliveryBoxDetail.user.userId})`,
      };

      setInputValue(inputValue);
    };
    defaultValue();
    setLoading(false);
  }, [value]);

  if (loading) {
    return <></>;
  }

  return (
    <AsyncSelect
      placeholder="사용자(이름)을 검색해주세요."
      noOptionsMessage={() => {
        return "사용자(이름)을 검색해주세요.";
      }}
      loadOptions={loadOptions}
      onChange={onChange}
      value={inputValue}
      cacheOptions
    />
  );
};

export default DeliveryBoxAsyncSelect;
